import React, { useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { CopilotRepositoryProvider, useCopilotRepositoryContext } from '@bingads-webui/inline-copilot';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

export const withCopilotDataServiceProvider = (WrappedComponent) => {
  const Wrapper = (props) => {
    const {
      i18n,
      finalUrl,
      permissions,
    } = props;

    const serverContext = useContext(ServerContext);

    const useClipchamp = permissions && permissions.dynamic && permissions.dynamic.VideoTemplateUI;

    return (
      <CopilotRepositoryProvider
        campaignId="-1"
        finalUrl={finalUrl}
        locale={i18n.getLocale()}
        recommendationType="PMax"
        serverContext={serverContext}
        useClipchamp={useClipchamp}
      >
        <WrappedComponent {...props} />
      </CopilotRepositoryProvider>
    );
  };

  Wrapper.displayName = `withCopilotRepositoryProvider(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
};

export const withCopilotDataServiceConsumer = (WrappedComponent) => {
  const CompWithService = (props) => {
    const copilotDataService = useCopilotRepositoryContext();

    return (<WrappedComponent copilotDataService={copilotDataService} {...props} />);
  };

  CompWithService.displayName = `withCopilotDataServiceConsumer(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(CompWithService, WrappedComponent);

  return CompWithService;
};

export const withCopilotDataServiceLoaded = (WrappedComponent) => {
  const Wrapper = withCopilotDataServiceProvider(withCopilotDataServiceConsumer(WrappedComponent));

  Wrapper.displayName = `withCopilotDataServiceLoaded(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
};
